import React from "react"
import { Box, BoxProps, Flex, Stack } from "@chakra-ui/core"
import Body from "../typography/Body"
import CompareItem, { CompareItemProps } from "./CompareItem"
import { Button } from "../Buttons"
import MaxWidthGrid from "../Layout/MaxWidthGrid"
import IconButton from "../Buttons/IconButton"
import { bp } from "../../utils/MediaQueries"

type CompareBarProps = BoxProps & {
  bikes?: CompareItemProps["bike"][]
  onRemoveBike: (bike: CompareItemProps["bike"]) => void
  onCompare: VoidFunction
  onClose: VoidFunction
  isSidebarOpen?: boolean
}

export default function CompareBar({
  bikes = [],
  onRemoveBike,
  onClose,
  onCompare,
  isSidebarOpen,
  ...props
}: CompareBarProps) {
  const bpGap = [null, null, null, null]

  if (!isSidebarOpen) {
    bpGap.shift()
  }

  return (
    <Box d={bp("none", "block")} w="100%" backgroundColor="primary" {...props}>
      <MaxWidthGrid
        pt={[...bpGap, "0.5625rem", "1.1875rem"]}
        pb="1.125rem"
        px="1.25rem"
        alignItems="center"
        gridTemplateAreas={[
          `
            "${"label ".repeat(14)}"
            "${"bikes ".repeat(14)}"
            "${"compare ".repeat(13)} close"
          `,
          ...bpGap,
          `
            "${"label ".repeat(14)}"
            "${"bikes ".repeat(10)}${"compare ".repeat(3)} close"
          `,
          `"label ${"bikes ".repeat(9)}${"compare ".repeat(3)} close"`,
        ]}
        gridRowGap="0.5rem"
        gridColumnGap="0.5rem"
      >
        <Flex align={[...bpGap, "baseline", "center"]} gridArea="label">
          <Body
            fontWeight="bold"
            color="white"
            w={[...bpGap, null, "5.7031rem"]}
            h={[...bpGap, "auto", "2.75rem"]}
          >
            Select up to 3 Bikes
          </Body>
        </Flex>

        <Stack isInline spacing="0.5rem" gridArea="bikes">
          {[bikes[0], bikes[1], bikes[2]].map((bike, index) => (
            <CompareItem
              key={index}
              bike={bike}
              onClose={() => onRemoveBike(bike)}
              flexGrow={1}
              flexBasis={0}
            />
          ))}
        </Stack>
        <Flex align="center" gridArea="compare">
          <Box
            display={["none", ...bpGap, "block"]}
            width="5%"
            maxWidth="2rem"
            flexGrow={0}
          />
          <Button
            px="0"
            flexGrow={2}
            backgroundColor="white"
            color="primary"
            _hover={{ backgroundColor: "noon" }}
            _active={{ backgroundColor: "noon" }}
            onClick={onCompare}
          >
            Compare
          </Button>
        </Flex>
        <Flex align="center" justify="center" gridArea="close">
          <IconButton
            aria-label="Close compare"
            icon="close"
            w="3rem"
            h="3rem"
            size="0.75rem"
            backgroundColor="rgba(255,255,255,0.2)"
            color="white"
            onClick={onClose}
          />
        </Flex>
      </MaxWidthGrid>
    </Box>
  )
}
